import { Divider, Form } from 'antd'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import Date from 'components/Date/Date'
import Flex from 'components/Flex'
import Label from 'components/Label/Label'
import { OfferAcceptExp, SingleOffer , getUserCorpList} from 'modules/OfferLetter/actions'
import {
  OfferColumn,
  Outline,
  StyledSelect,
} from 'modules/OfferLetter/Style/style'
import { FormItem } from 'modules/Resume/DrawerComponents/AdditionalDetails/style'
import {
  Address,
  FooterFlex,
  LeftText,
  Name1,
  NameAdd,
  RightText,
  TopHeading,
} from 'modules/Roles/Style/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch ,useSelector} from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { formatNumber } from 'utils/formatNumber'
import { permittedEventCruds } from 'utils/permissionsValidation'
import {
  getNotificationCatalogues,
  sendNotificationBulkEmail,
  sendInAppNotification
} from 'modules/ManageProfile/actions'


const OfferAccept = () => {
  const dateFormat = 'DD/MM/YYYY'
  const permissions = useSelector(state => state?.auth?.permissions)
  let stdData = useSelector(state => state?.studentData?.studentDetails)
  const permittedEvents = permittedEventCruds(permissions, 'OFFER RELEASED')
  const [offerAccpectTemplate, setOfferAccpectTemplate] = useState(null)
  const params = useParams()
  const dispatch = useDispatch()
  const navigate = new useNavigate()
  const TimelineList = [
    {
      name: 'Immediately',
      value: 'Immediately',
    },
    {
      name: 'In 15 days',
      value: 'In 15 days',
    },
    {
      name: '15 - 30 days',
      value: '15 - 30 days',
    },
    {
      name: '1 - 2 Months',
      value: '1 - 2 Months',
    },
    {
      name: '2 - 3 Months',
      value: '2 - 3 Months',
    },
  ]
  const [data, setData] = useState({})
  const [corporateEmailList, setCorporateEmailList] = useState([])
  useEffect(() => {
    ;(async () => {
      if (data?.role?.corporate?.id) {
        let responce = await dispatch(getUserCorpList(data?.role?.corporate?.id))
        setCorporateEmailList(responce)
      }
    })()

    return () => {
      // this now gets called when the component unmounts
    }
  }, [data])
  const offerAcceptEX =
    permittedEvents?.find(item => item.events?.eventName === 'ACTION')
      ?.events || ''


      useEffect(() => {
        (async () => {
          if (offerAcceptEX?.id) {
            let responce = await dispatch(getNotificationCatalogues(offerAcceptEX?.id))
            const filteredArray = responce?.CatalogueData?.filter(
              item =>
                item.eventNotificationTemplate &&
                item.eventNotificationTemplate.templateName ===
                  'Offer Letter Accepted EX' &&
                item.eventNotificationTemplate.eventNotificationType &&
                item.eventNotificationTemplate.eventNotificationType.name ===
                  'E-Mail'
            )
    
            if (filteredArray?.length > 0) {
              setOfferAccpectTemplate(filteredArray[0].eventNotificationTemplate)
            }
          }
        })()
    
        return () => {
          // this now gets called when the component unmounts
        }
      }, [offerAcceptEX])

  useEffect(() => {
    ;(async () => {
      let responce = await dispatch(SingleOffer(params.offerID))
      if (responce?.status >= 200 && responce?.status <= 300)
        setData(responce?.data?.data)
    })()

    return () => {
      // this now gets called when the component unmounts
    }
  }, [])
  const [form] = Form.useForm()
  const CheckIcons = logo => {
    if (logo === null) {
      return (
        <Avatar
          background
          size={42}
          IconName={data?.role?.corporate?.name[0]}
          font={18}
        />
      )
    } else {
      return <Avatar size={42} src={logo} />
    }
  }
  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return ' Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return YOE?.length > 0
            ? ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
            : ` 0 - 1 Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }

  const [listData, setListData] = useState([])
  useEffect(() => {
    let otherData = [
      {
        id: 1,
        name: 'Salary',
        value: `₹ ${formatNumber(data?.salary)} ${
          data.frequecy === 'ANNUALLY' ? ` per annum` : ` per month`
        }`,
      },
      {
        id: 2,
        name: 'Job Type',
        value: `${checkJobTypeLevel(
          data?.role?.jobTypeLevels,
          data?.role?.yearOfExperience
        )} (${
          data?.role?.jobType === 'FULL_TIME' ? 'Full Time' : 'Part Time'
        })`,
      },
      {
        id: 3,
        name: 'Location',
        value: `${data?.jobLocation}`,
      },
      {
        id: 4,
        name: 'Offer Received on',
        value: `${moment(data?.createdAt)?.format('DD/MM/YYYY')}`,
      },
      {
        id: 5,
        name: 'Offer Valid',
        value: `${moment(data?.offerExpireDate)?.format('DD/MM/YYYY')}`,
      },
    ]
    setListData(otherData)
  }, [data])

  const offerAccept = async value => {
 
    let payload = {
      isAccept: true,
      joiningDate: moment(value?.joiningDate, 'DD/MM/YYYY')?.format(
        'YYYY/MM/DD'
      ),
      noticePeriod: value?.noticePeriod,
    }
    let response = await dispatch(
      OfferAcceptExp(data?.roleId, data?.driveId, payload)
    )
    if (response?.status >= 200 && response?.status <= 300) {
      
      let InAppObj = 
      {
        notification: {
          students: [
            {
            ids: [stdData?.id],
        userIds: [],
        roles: ["Student"],
        issuer: "corporate",
        createFor: "student",
        inApp: true,
        body: `Congratulations! You've accepted the offer for the ${data?.role?.tittle} position at ${data?.role?.corporate?.name}`,
        tag: "Offer",
        }] 
      }
    }
      dispatch(sendInAppNotification(InAppObj))
      const final = corporateEmailList?.list?.map(item => {
        const currentDate = moment().format('DD MMM YYYY')
        let name = stdData?.admin?.first_name + ' ' + stdData?.admin?.last_name
        const template = offerAccpectTemplate?.templateText
          ?.replace('{corporateName}', data?.role?.corporate?.name)
          ?.replaceAll('{studentName}', name)
          ?.replace('{roleName}', data?.role?.tittle)
          ?.replace('{dd/mmm/yyyy}', currentDate)
        return {
          to: item?.email,
          subject:
          offerAccpectTemplate?.subject ||
            'Drive Scheduled Notification - Pluginlive',
          htmlBody: template,
        }
      })
      dispatch(sendNotificationBulkEmail(final))
      navigate(`/offerReceived`)
    }
  }
  const onChangeGender = data => {
    form.setFieldsValue({ noticePeriod: data })
  }

  const validateDateOfBirth = dateString => {
    const date = moment(dateString, 'DD/MM/YYYY', true)
    return date.isValid();

  }

  const handleDateChange = (date, dateString) => {
    const isValidDate = validateDateOfBirth(dateString)

    if (!isValidDate) {
      form.setFieldsValue({ joiningDate: null })
    }
    if (isValidDate) {
      form.setFieldsValue({ joiningDate: dateString })
    }
  }

  const cancel = () => {
    navigate(`/offerReceived`)
  }
  return (
  
      <Outline>
        <OfferColumn span={14}>
          <div style={{ padding: '30px' }}>
            <TopHeading flexStart>Joining Date</TopHeading>
            <Form
              style={{ width: '100%' }}
              scrollToFirstError
              onFinish={offerAccept}
              id={'negotiateForm'}
              layout="vertical"
              form={form}
            >
              <FormItem
                name="joiningDate"
                rules={[
                  {
                    required: true,
                    message: 'Please Select Joining Date!',
                  },
                ]}
              >
                <Control flexStart top="20px" column>
                  <Label>Select Joining Date *</Label>

                  <Date
                    format={dateFormat}
                    placeholder={dateFormat}
                    disabledDate={d => !d || d.isBefore(moment())}
                    onChange={handleDateChange}
                  />
                </Control>
              </FormItem>
              <Control flexStart top="10px" column>
                <Label>Notice Period *</Label>
                <FormItem
                  name="noticePeriod"
                  rules={[
                    {
                      required: true,
                      message: 'Please Select Notice Period!',
                    },
                  ]}
                >
                  <StyledSelect
                    placeholder="Select"
                    options={TimelineList}
                    placement={'bottomRight'}
                    onChange={onChangeGender}
                    valueParam="value"
                    nameParam="name"
                  />
                </FormItem>
              </Control>
              <Divider />

              <FooterFlex right>
                <Button.Secondary text="Cancel" onClick={cancel} />

                <Button.Primary htmlType="submit" text={'Submit'} />
              </FooterFlex>
            </Form>
          </div>
        </OfferColumn>
        <OfferColumn span={9}>
          <Flex centerVertically>
            {CheckIcons(data?.role?.corporate?.logo)}
            <NameAdd column flexStart>
              <Address>{data?.role?.corporate?.name}</Address>
              <Name1>{data?.role?.tittle}</Name1>
            </NameAdd>
          </Flex>

          {listData?.map((item, index) => (
            <div key={index+"list"} style={{ width: '100%' }}>
              <LeftText>{item.name}</LeftText>

              <RightText>{item.value}</RightText>
            </div>
          ))}
        </OfferColumn>
      </Outline>
    
  )
}
export default OfferAccept
